module.exports = __webpack_public_path__ + "img/double-ring.619eec3e.gif";